/**
 * The vendor notice (`.vnotice`, ADR-002 §21.2, invariant I6): shown beside every control that opens the microphone,
 * before it opens. That is [Record] on the recorder card, and [Try again] in the microphone-blocked note, which calls
 * record() and reopens the mic from outside the card.
 */
import { Icon } from '../../ui/Icon';
import { VENDOR_NOTICE } from './notice';

export function VendorNotice() {
  return (
    <div className="vnotice" data-testid="vendor-notice">
      <Icon name="alert" size={14} />
      <span>{VENDOR_NOTICE}</span>
    </div>
  );
}
